const modalities = [
  {
    name: "Meditação",
    isNew: true,
    icon: "ri-psychotherapy-line",
    desc: "Uma experiência imersiva de relaxamento profundo. Promove o isolamento dos estímulos externos, proporcionando relaxamento físico e mental, especialmente para mentes agitadas e inquietas.",
    color: "from-[#CDE3BB] to-[#edf7e4]",
    iconBg: "bg-[#BCD033]/30",
    iconColor: "text-[#008C51]",
  },
  {
    name: "Yoga",
    isNew: false,
    icon: "ri-body-scan-line",
    desc: "Movimentos suaves combinados com respiração, promovendo alongamento, equilíbrio e consciência corporal de forma progressiva.",
    color: "from-[#F0CDCD]/50 to-[#fdf5f5]",
    iconBg: "bg-[#F0CDCD]/70",
    iconColor: "text-[#008C51]",
  },
  {
    name: "Tai Chi Chuan",
    isNew: false,
    icon: "ri-contrast-line",
    desc: "Prática milenar de origem chinesa com movimentos lentos e fluidos que estimulam coordenação, relaxamento e conexão entre corpo e mente.",
    color: "from-[#A4D8DE]/40 to-[#eaf6f8]",
    iconBg: "bg-[#A4D8DE]/60",
    iconColor: "text-[#008C51]",
  },
  {
    name: "LPF",
    isNew: false,
    icon: "ri-lungs-line",
    desc: "Low Pressure Fitness: método que une técnicas posturais e respiratórias para ativar a musculatura profunda do abdômen, melhorando postura e consciência corporal.",
    color: "from-[#CDE3BB]/70 to-[#f3fbed]",
    iconBg: "bg-[#BCD033]/25",
    iconColor: "text-[#008C51]",
  },
  {
    name: "Mobilidade Articular",
    isNew: false,
    icon: "ri-walk-line",
    desc: "Prática focada em ampliar a mobilidade das articulações e alongar o corpo de forma consciente, ajudando a melhorar a flexibilidade, prevenir desconfortos e preparar o corpo para o movimento do dia a dia.",
    color: "from-[#A4D8DE]/30 to-[#f0fafb]",
    iconBg: "bg-[#A4D8DE]/50",
    iconColor: "text-[#008C51]",
  },
];

export default function MindModalities() {
  return (
    <section id="modalidades-mente" className="py-20 bg-[#CDE3BB]/20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <span className="text-[#BCD033] text-sm font-bold tracking-widest uppercase">Bloco 1 · 08h30–10h00</span>
            <h2 className="text-4xl font-extrabold text-[#008C51] mt-1">Modalidades Mente</h2>
            <p className="text-gray-500 mt-2 text-sm max-w-md">
              Práticas voltadas para o cuidado da mente: presença, respiração e consciência corporal.
            </p>
          </div>
          <div className="bg-[#CDE3BB] text-[#008C51] text-sm font-bold px-5 py-2 rounded-full whitespace-nowrap">
            <i className="ri-check-double-line mr-1" />
            1 aula por pessoa
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {modalities.map((mod, i) => (
            <div
              key={mod.name}
              className={`relative bg-gradient-to-br ${mod.color} rounded-2xl p-6 transition-transform hover:-translate-y-1 duration-200 border border-transparent hover:border-[#BCD033]/30${i === modalities.length - 1 && modalities.length % 2 !== 0 ? " md:col-span-2 md:max-w-[calc(50%-12px)] md:mx-auto md:w-full" : ""}`}
            >
              {mod.isNew && (
                <span className="absolute top-4 right-4 bg-[#F0CDCD] text-[#008C51] text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1">
                  <i className="ri-sparkling-2-line text-xs" />
                  NOVO
                </span>
              )}
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${mod.iconBg} mb-4`}>
                <i className={`${mod.icon} text-2xl ${mod.iconColor}`} />
              </div>
              <h3 className="text-xl font-extrabold text-[#008C51] mb-2">{mod.name}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{mod.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
